import { render, staticRenderFns } from "./activate_account.vue?vue&type=template&id=408722a2&"
import script from "./activate_account.vue?vue&type=script&lang=js&"
export * from "./activate_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports